import { type, auto, define, Record } from 'type-r'

@define
export default class FilterModel extends Record {
    @auto("") bulkReview: string
    @auto("") search: string
    @auto("") status: string
}
